import Feeds from "components/Feeds"
import VueComponent from "../vue_component"

export default VueComponent(Feeds)
